import React from 'react';

const PaginationPoint = (props) => {
    return <li className={props.isActive}>
        <button onClick={props.onClick} className="btn">{props.setNumber}</button>
    </li>
}

export default PaginationPoint;